const prevbtn = document.querySelector("#leftArrow");
const nextbtn = document.querySelector("#rightArrow");
const items = document.querySelectorAll(".sale-img");
console.log(items);
const itemCountStart = document.getElementById("sellLengthDiv");
var itemCountString = itemCountStart.innerText;
var itemCount = parseInt(itemCountString, 10);
let curSlide = 0;
let slideTest = 0;
const testLength = items.parentElement;
console.log(testLength);
const testMovement = items[0].offsetWidth;
console.log(testMovement);
let loopLeftAmount = 0;
let loopRightAmount = 0;
let moving = false;

const totalItems = items.length;
const slideWidth = "400px";
const slideWidthPx = parseInt(slideWidth, 10);
const sliderLengthTotal = slideWidthPx * totalItems;
let sliderLength = slideWidthPx * totalItems;
let currentSliderLength = 0;
let sliderTotal = sliderLength - currentSliderLength;
let slideOrder = 0;
let compass = true;
let slidePosition = 0;

function moveCardsHorizontally(amountToMove) {
	for (const item of items) {
		if (item instanceof HTMLElement) {
			item.style.transform = `translateX(${amountToMove}px)`;
		}
	}
}
function getNewPosition(dir) {
	totalWidth = items[0].parentElement.clientWidth;
	singleAmountToMoveHorizontally = items[0].offsetWidth;
	if (dir === "right") {
		positionX = Math.floor(singleAmountToMoveHorizontally * curSlide);
	} else if (dir === "left") {
		positionX = Math.floor(positionX - singleAmountToMoveHorizontally);
	}
	return positionX;
}
function disableInteraction() {
	moving = true;
	setTimeout(() => {
		moving = false;
	}, 500);
}
function toggleActiveClass(oldIndex, newIndex) {
	items[oldIndex].classList.add("drought");
	items[oldIndex].classList.remove("growthCycle");
	items[newIndex].classList.remove("drought");

	items[newIndex].classList.add("growthCycle");
}
function moveCardsDotsHorizontally(dir) {
	moveCardsHorizontally(-getNewPosition(dir));
	storeOldIndex = curSlide;
	if (dir === "left") {
		curSlide -= 1;
	} else {
		curSlide += 1;
	}
	toggleActiveClass(storeOldIndex, curSlide);
}
function determineDifference(initial, final) {
	return Math.floor(final - initial);
}
// Set event listeners
if (nextbtn && prevbtn) {
	nextbtn.onclick = function () {
		if (!moving) {
			disableInteraction();
			if (curSlide === totalItems - 1) {
				return;
			} else {
				moveCardsDotsHorizontally("right");
			}
		}
	};

	prevbtn.onclick = function () {
		if (!moving) {
			disableInteraction();
			if (curSlide === 0) {
				return;
			} else {
				moveCardsDotsHorizontally("left");
			}
		}
	};
}

items.forEach((item, index) => {
	item.addEventListener("click", () => {
		if (index > curSlide) {
			loopRightAmount = Math.floor(determineDifference(index, curSlide) * -1);
			for (let i = 0; i < loopRightAmount; i++) {
				moveCardsDotsHorizontally("right");
			}
		} else {
			loopLeftAmount = determineDifference(index, curSlide);
			for (let j = 0; j < loopLeftAmount; j++) {
				moveCardsDotsHorizontally("left");
			}
		}
	});
});
const slideStart = function () {
	items[0].classList.remove("drought");
	items[0].classList.add("growthCycle");
};

slideStart();
